export const SORT_BY_KEY = 'sortBy'
export const ASCENDING_KEY = 'asc'
export const PAGE_KEY = 'page'
export const SEARCH_FOR_KEY = 'searchFor'
export const SELECTED_NETWORKS_KEY = 'selectedNetworks'
export const SELECTED_PROTOCOLS_KEY = 'selectedProtocols'
export const SELECTED_CURATORS_KEY = 'selectedCurators'
export const SELECTED_TAGS_KEY = 'selectedTags'
export const SELECTED_TOKENS_KEY = 'selectedTokens'
export const SELECTED_COLLATERALS_KEY = 'selectedCollaterals'
export const BORROW_MARKET_SIZE_FROM_BOUND_KEY = 'borrowMarketSizeFrom'
export const BORROW_MARKET_SIZE_TO_BOUND_KEY = 'borrowMarketSizeTo'
export const BORROW_LIQUIDITY_FROM_BOUND_KEY = 'borrowLiquidityFrom'
export const BORROW_LIQUIDITY_TO_BOUND_KEY = 'borrowLiquidityTo'
export const TVL_FROM_BOUND_KEY = 'tvlFrom'
export const TVL_TO_BOUND_KEY = 'tvlTo'
export const INCLUDE_REWARDS_KEY = 'includeRewards'
export const APY_RANGE_KEY = 'apyRange'
export const ONLY_TRANSACTIONAL_KEY = 'onlyTransactional'
export const MIN_VAULT_SCORE_KEY = 'minVaultScore'
export const DISCOVER_PAGE_KEYS = {
  vaults: {
    page: PAGE_KEY,
    search: SEARCH_FOR_KEY,
    assets: SELECTED_TOKENS_KEY,
    protocols: SELECTED_PROTOCOLS_KEY,
    networks: SELECTED_NETWORKS_KEY,
    sortBy: SORT_BY_KEY,
    ascending: ASCENDING_KEY,
  },
  fixedTerm: {
    page: 'fixedTermPage',
    search: 'fixedTermSearch',
    assets: 'fixedTermAssets',
    protocols: 'fixedTermProtocols',
    networks: 'fixedTermNetworks',
    sortBy: 'fixedTermSortBy',
    sortOrder: 'fixedTermSortOrder',
  },
} as const
export const ANALYTICS_PAGE_KEYS = {
  TVL: {
    key: 'tvlTab',
  },
  benchmarks: {
    selectedVaults: 'benchmarkVaults',
    selectedBenchmarks: 'benchmarkBenchmarks',
  },
}
export const OPPORTUNITY_PAGE_KEYS = {
  tab: {
    key: 'tab',
  },
}
export const BORROW_MARKET_PAGE_KEYS = {
  tab: {
    key: 'tab',
  },
}
